<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Intermediary Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-flex xs12>
            <form data-vv-scope="queryForm">
              <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> Filters
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-text-field data-vv-scope="queryForm" v-model="filter.inter" :label="label.inter" data-vv-name="inter" :data-vv-as="label.inter" :error-messages="errors.collect('inter')"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field data-vv-scope="queryForm" v-model="filter.intermediaryName" :label="label.intermediaryName" data-vv-name="intermediaryName" :data-vv-as="label.intermediaryName" :error-messages="errors.collect('intermediaryName')"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-flex class="mt-3" xs12>
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <!-- <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row">
                <td class="text-xs-left">{{ row.item.inter }}</td>
                <td class="text-xs-left">{{ row.item.name }}</td>
                <td class="text-xs-center" >
                  <v-btn icon v-on="on" color="primary" text type="submit" @click.native="assignInterNo(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table> -->
            <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :server-items-length="totalItems"
            :custom-filter="customSearch"
            :no-data-text="noDataText"
            v-bind:options.sync="pagination"
            >
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.inter }}</td>
                <td class="text-xs-left">{{ row.item.name }}</td>
                <td class="text-xs-center" >
                  <v-btn icon color="primary" text type="submit" @click.native="assignInterNo(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  props: {
    'menu': Object
  },
  data() {
    return {
      loading: false,
      toogleArray: [false],
      items: [],
      totalItems: 0,
      headers: [
        { text: 'Intermediary No.', value: 'inter' },
        { text: 'Name', value: 'name' },
        TableConst.tableActionHeader
      ],
      label: {
        intermediaryName: 'Name',
        inter: 'Intermediary No.'
      },
      filter: {
        intermediaryName: undefined,
        inter: undefined
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  mounted() {
    this.doClearFilters()
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getAllInterList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map(element => {
                const convertedList = {
                  inter: element.inter,
                  name: element.name
                }
                this.items.push(convertedList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    assignInterNo(data) {
      this.$emit('assignInterNoInfo', data)
      this.$emit('close')
    },
    doClearFilters() {
      this.filter.inter = ''
      this.filter.intermediaryName = ''
      this.doInit()
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.doInit(false)
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  watch: {
    'pagination': function(value) {
      this.doInit(false)
    },
    'acctNum': function(value) {
      this.doInit(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
